<template>
	<PreviousStepsData
		hideProcessWorkflows
		:isTableOnly="isTableOnly"
		:prevStepsSubMenuTitle="prevStepsSubMenuTitle"
		:errorMessage="errorMessage"
		:searchString="searchString"
		:useWithFormulas="useWithFormulas"
		:contentRectYAxis="contentRectYAxis"
		:isTableColumnInput="isTableColumnInput"
		:allowTableSelection="allowTableSelection"
		:expandedItemId="expandedItemId"
		:dataInputParam="dataInputParam"
		:dataSourcesItems="dataSourcesItems"
		v-on="$listeners"
	/>
</template>

<script>
import { mapGettersShorthand } from '@/store/utils/mappers';
import PreviousStepsData from '@/components/DataInput/DataInputMenu/ContentSwitcher/PreviousStepsData';
import { getWorkflowDraftVersion } from '@/store/modules/workflows/getters';

export default {
	name: 'ProcessWorkflowPreviousStepsData',
	components: { PreviousStepsData },
	props: {
		isTableOnly: { type: Boolean },
		errorMessage: { type: String },
		searchString: { type: String },
		useWithFormulas: { type: Boolean },
		contentRectYAxis: { type: Number },
		isTableColumnInput: { type: Boolean },
		allowTableSelection: { type: Boolean },
		expandedItemId: { type: [String, Number, null] },
		dataInputParam: { type: Object },
		selectedProcessWorkflowId: { type: Number },
		dataSourcesItems: { type: Array },
	},
	methods: {
		unExpandItem() {
			// Called from Parent
			if (this.expandedItemId) {
				// When we're in [insert data menu top level] -> [workflow from process] -> [step]
				this.$emit('set-expanded-item-id', null);
			} else {
				// When we're in [insert data menu top level] -> [workflow from process]
				this.$emit('process-workflow-selected', null);
			}
		},
		selectProcessWorkflow(itemId) {
			this.$emit('process-workflow-selected', itemId);
		},
	},
	computed: {
		...mapGettersShorthand({ getWorkflowDraftVersion }),
		selectedProcessWorkflowTitle() {
			return this.getWorkflowDraftVersion(this.selectedProcessWorkflowId).workflow_title;
		},
		prevStepsSubMenuTitle() {
			return `Steps from ${this.selectedProcessWorkflowTitle}`;
		},
	},
};
</script>
